<template>
    <div>
        <van-nav-bar
            title="领优惠券"
            right-text="我的券"
            @click-right="onClickRight"
        />
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div 
                 v-for="(item,index) in dataList" :key="item.id"
                class="stamp" 
                v-bind:class="{
                    'stamp-1': index % 4 + 1 == 1,
                    'stamp-2': index % 4 + 1 == 2,
                    'stamp-3': index % 4 + 1 == 3,
                    'stamp-4': index % 4 + 1 == 4, 
                    'have': (item.received || item.expired || item.amount == 0)
                }"
            >
            <div class="par">
                <p>{{item.shop_name}}</p>
                <span>满 {{item.full_money}}</span>
                <br/>
                <span>减 {{item.reach_money}}</span>
                <p>{{ item.document_number }}</p>
            </div>
            <div class="copy">
                <span>{{ item.project_extra.name }}</span>
                <p v-if="!item.expired">{{ item.begin_date | moment("YYYY-MM-DD") }}</p>
                <p v-if="!item.expired">{{ item.end_date | moment("YYYY-MM-DD") }}</p>
                <a v-if="!item.received && !item.expired && item.amount > 0" @click="receive(item)">立即领取</a>
                <p v-if="!item.received && !item.expired && item.amount == 0">已领完</p>
                <p v-if="item.received && !item.expired">已领取</p>
                <p v-if="item.expired">已过期</p>
            </div>
            </div>
        </van-list>
    </div>
</template>

<script>
import { NavBar, List, Button, Toast } from 'vant';
import { BulkCouponApi } from '@/api/shop'
import { CouponApi } from '@/api/vip'
import { toErrorPage } from '@/utils/usePage'

export default {
    components:{
        [NavBar.name]: NavBar,
        [List.name]: List,
        [Button.name]: Button,
        [Toast.name]: Toast
    },
    data() {
        return {
            dataList: [],
            loading: false,
            finished: false,
            query: {
                page: 0
            }
        }
    },
    mounted(){
    },
    methods:{
        onLoad() {
            this.query.page+=1
             this.getBulkCoupon()
        },
        getBulkCoupon(){
            var that = this
            that.axios.get(BulkCouponApi, {params: that.query}).then((ret) => {
                that.loading = false
                if (ret.flag) {
                    let it = ret.details
                    it.results.forEach(item => {
                        that.dataList.push(item)
                    })
                    if (it.results == null || it.results.length ===0 || it.next == null) {
                        that.finished = true
                        return
                    } else {
                        Toast(ret.info)
                    }
                } else {
                    toErrorPage(that,'',ret.info,null)
                }
            })
        },
        receive(item){
            Toast('领取中...')
            var that = this
            let data = {
                bulk_coupon: item.id,
                shop: item.shop,
                project_type: item.project_type,
                project_id: item.project_id,
                full_money: item.full_money,
                money: item.reach_money,
                begin_date: item.begin_date,
                end_date: item.end_date,
                source_type: 2
            }
            that.axios.post(CouponApi, data).then((ret) => {
                console.log(ret)
                that.dataList.forEach(item => {
                    if(data.bulk_coupon === item.id){
                        item.received = true
                        Toast('领取成功')
                        return
                    }
                })
            }).catch(function (error) {
                Toast(error)
            })
        },
        onClickRight(){
            this.$router.push(`/nt/user/mycoupon`)
        }
    }
}
</script>

<style lang="less" scoped>
.stamp {
        width: 92%;
        padding: 0 0px;
        margin: 4%;
        position: relative;
        overflow: hidden;
        p {
            padding: 0;
            margin: 0;
        }
        &:before {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 10px;
            right: 10px;
            z-index: -1;
        }
        .par {
            float: left;
            padding: 16px 15px;
            width: 51%;
            border-right: 2px dashed rgba(255, 255, 255, 0.3);
            text-align: left;
            p {
                color: #fff;
                font-size: 16px;
                line-height: 21px;
                margin-bottom: 15px;
            }
            span {
                font-size: 24px;
                color: #fff;
                margin-right: 5px;
                line-height: 30px;
            }
        }
        .copy {
            padding: 30px 0;
            vertical-align: text-bottom;
            font-size: 18px;
            color: rgb(255, 255, 255);
            text-align: center;
            line-height: initial;
            padding: 10px 6px 10px 12px;
            a {
                background-color: #fff;
                color: #333;
                font-size: 14px;
                text-decoration: none;
                padding: 5px 10px;
                border-radius: 3px;
                &:active {
                    background-color: gainsboro;
                }
            }
            p {
                margin: 8px 0;
                font-size: 16px;
            }
        }
    }
    .stamp-1 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #F39B00 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #F39B00;
        }
    }
    .stamp-2 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #D24161 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #D24161;
        }
    }
    .stamp-3 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #7EAB1E 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #7EAB1E;
        }
    }
    .stamp-4 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #50ADD3 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #50ADD3;
        }
    }
    .have {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #C1C1C1 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #C1C1C1;
        }
    }
</style>